export const lotRequestInterval = 10000;
